<div *ngIf="isLoading$ | async" class="overlay">
  <mat-progress-spinner mode="indeterminate" diameter="100" color="primary"></mat-progress-spinner>
</div>